import React, { useState } from "react";
import { useParams } from "react-router-dom";
import {
  Box, Container, Typography, TextField, Button, Grid
} from "@mui/material";
import { db, storage } from "../firebase";
import { collection, addDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

export default function Apply() {
  const { jobTitle } = useParams();

  const [formData, setFormData] = useState({
    name: "",
    education: "",
    experience: "",
    resume: null
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setFormData(prev => ({ ...prev, resume: e.target.files[0] }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let resumeURL = "";
    if (formData.resume) {
      const storageRef = ref(storage, `resumes/${formData.resume.name}`);
      await uploadBytes(storageRef, formData.resume);
      resumeURL = await getDownloadURL(storageRef);
    }

    await addDoc(collection(db, "jobApplications"), {
      jobTitle,
      name: formData.name,
      education: formData.education,
      experience: formData.experience,
      resumeURL,
      timestamp: new Date()
    });

    alert("Application submitted!");
    setFormData({ name: "", education: "", experience: "", resume: null });
  };

  return (
    <Box sx={{ py: 10, backgroundColor: "#121212", minHeight: "100vh", color: "white" }}>
      <Container maxWidth="sm">
        <Typography variant="h4" fontWeight={700} sx={{ mb: 4 }}>
          Apply for {jobTitle}
        </Typography>

        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>

            {/* FULL NAME */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Full Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                InputLabelProps={{ style: { color: "#B0BEC5" } }}
                InputProps={{
                  style: {
                    backgroundColor: "#1E1E1E",
                    color: "white",
                    borderRadius: 8
                  }
                }}
              />
            </Grid>

            {/* EDUCATION */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Education"
                name="education"
                value={formData.education}
                onChange={handleChange}
                required
                InputLabelProps={{ style: { color: "#B0BEC5" } }}
                InputProps={{
                  style: {
                    backgroundColor: "#1E1E1E",
                    color: "white",
                    borderRadius: 8
                  }
                }}
              />
            </Grid>

            {/* EXPERIENCE */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Experience"
                name="experience"
                value={formData.experience}
                onChange={handleChange}
                required
                InputLabelProps={{ style: { color: "#B0BEC5" } }}
                InputProps={{
                  style: {
                    backgroundColor: "#1E1E1E",
                    color: "white",
                    borderRadius: 8
                  }
                }}
              />
            </Grid>

            {/* RESUME UPLOAD */}
            <Grid item xs={12}>
              <Button
                variant="contained"
                component="label"
                sx={{
                  backgroundColor: "#1976D2",
                  color: "white",
                  fontWeight: 600,
                  borderRadius: 2,
                  "&:hover": { backgroundColor: "#1565C0" }
                }}
              >
                Upload Resume
                <input type="file" hidden onChange={handleFileChange} />
              </Button>

              {formData.resume && (
                <Typography variant="body2" sx={{ mt: 1, color: "#B0BEC5" }}>
                  {formData.resume.name}
                </Typography>
              )}
            </Grid>

            {/* SUBMIT BUTTON */}
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                color="success"
                sx={{
                  fontWeight: 700,
                  borderRadius: 2,
                  px: 4,
                  py: 1.5
                }}
              >
                Submit Application
              </Button>
            </Grid>

          </Grid>
        </form>
      </Container>
    </Box>
  );
}